import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./NavBar.scss";

const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleLinkClick = () => {
    // Close the menu after navigating on mobile
    setIsMenuOpen(false);
  };

  return (
    <nav className="main-nav">
      <div className="logo">
        <Link to="/">
          <img src="/boalls-icon.png" alt="Logo" />
        </Link>
      </div>

      <button
        className="menu-toggle"
        type="button"
        onClick={toggleMenu}
        aria-label="Toggle navigation menu"
        aria-expanded={isMenuOpen}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div className={`nav-links ${isMenuOpen ? "open" : ""}`}>
        <ul>
          <li>
            <NavLink to="/about" onClick={handleLinkClick}>
              About
            </NavLink>
          </li>
          <li>
            <NavLink to="/services" onClick={handleLinkClick}>
              Services
            </NavLink>
          </li>
          <li>
            <NavLink to="/feedback" onClick={handleLinkClick}>
              Feedback
            </NavLink>
          </li>
          <li>
            <NavLink to="/contact" onClick={handleLinkClick}>
              Contact
            </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default NavBar;
